import { render, staticRenderFns } from "./KnowledgeBaseDetailComponent.vue?vue&type=template&id=ee0b4802"
import script from "./KnowledgeBaseDetailComponent.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports